import { render } from "./registerView.vue?vue&type=template&id=7daf6ce2&scoped=true"
import script from "./registerView.vue?vue&type=script&lang=js"
export * from "./registerView.vue?vue&type=script&lang=js"

import "./registerView.vue?vue&type=style&index=0&id=7daf6ce2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7daf6ce2"],['__file',"src/components/auth/registerView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7daf6ce2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7daf6ce2', __exports__)) {
    api.reload('7daf6ce2', __exports__)
  }
  
  module.hot.accept("./registerView.vue?vue&type=template&id=7daf6ce2&scoped=true", () => {
    api.rerender('7daf6ce2', render)
  })

}


export default __exports__